import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

// Reloj compacto de fecha y hora actual (horario de México), pensado para
// mostrarse en la barra superior. Se actualiza solo cada minuto — no hace
// falta cada segundo para este uso.
export function RelojFechaHora({ claro = false }: { claro?: boolean }) {
  const [ahora, setAhora] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setAhora(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);

  const fecha = ahora.toLocaleDateString("es-MX", {
    timeZone: "America/Mexico_City",
    weekday: "long",
    day: "numeric",
    month: "long",
  });
  const hora = ahora.toLocaleTimeString("es-MX", {
    timeZone: "America/Mexico_City",
    hour: "2-digit",
    minute: "2-digit",
  });
  const fechaCapitalizada = fecha.charAt(0).toUpperCase() + fecha.slice(1);

  return (
    <div
      className={`flex items-center gap-1.5 text-xs font-medium ${
        claro ? "text-blue-200" : "text-slate-500"
      }`}
      title="Fecha y hora actual"
    >
      <Clock size={13} />
      <span className="hidden sm:inline">{fechaCapitalizada} ·</span> {hora}
    </div>
  );
}
